import { useState } from "react";
import { AlertTriangle, FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export function KitButton({ app }) {
  const [state, setState] = useState("idle");
  const go = async () => {
    setState("loading");
    try {
      const r = await api.get(`/applications/${app.id}/interview-kit.pdf`, { responseType: "blob", timeout: 90000 });
      const name = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "")?.[1] || "Interview-kit.pdf";
      const url = URL.createObjectURL(r.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: name });
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
      setState("idle");
      toast.success("Interview kit downloaded");
    } catch { setState("error"); }
  };
  return (
    <div className="flex flex-wrap items-center gap-3" data-tour="pt-interview-kit" data-testid="interview-kit">
      <Button variant="outline" onClick={go} disabled={state === "loading"} data-testid="download-kit-btn">
        {state === "loading" ? <Loader2 size={16} className="animate-spin" /> : <FileDown size={16} />} {state === "loading" ? "Preparing kit…" : "Download interview kit"}
      </Button>
      {state === "loading" && <span className="text-xs text-ink-muted" role="status">Writing tailored questions — usually under 30 seconds.</span>}
      {state === "error" && (
        <span role="alert" className="flex items-center gap-2 text-sm text-risk" data-testid="kit-error"><AlertTriangle size={14} aria-hidden="true" /> Couldn't create the kit — try again
          <Button size="sm" variant="ghost" onClick={go} data-testid="kit-retry-btn">Retry</Button></span>
      )}
    </div>
  );
}
